const BeforeAfterSaleModal = (props) => {
    return (
        <div className="sale-modal">
            <div className="sale-modal-content">
                <div className="sale-modal-header">
                    <h1><span className="sale-modal-close-icon" onClick={() => props.setShowSaleModal(prev => !prev)}>X</span></h1>
                    <h3>{props.title}</h3>
                </div>
            </div>
        </div>
    )
}

export default BeforeAfterSaleModal;